import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {HTHGameMode} from "./HTHGameMode";
import {IHTHGameData} from "./HTHData";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {HTH} from "../HTH";
import {HTHSound} from "../sound/HTHSound";
import {HTHHelper} from "../utils/HTHHelper";
import {RestoreUtils} from "../utils/RestoreUtils";


export class HTHPromoPanelConfig implements PromoPanelGameConfiguration{
    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "HighwayToHell",
            hasActionSpin: true,
            graphics: {backgroundTextureName: "MainBG"},
            getParsedData: (response: IHTHGameData, bet: number, prevResponse: IHTHGameData):ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: this.getSpinWin(response, bet, prevResponse),
                    isBigWin: this.isBigWin(response),
                    winType:  WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,

                }
                return parsedData;
            }
        };
    }


    private isBigWin(response:IHTHGameData): boolean {

        let win = response.spinWin;
        if (response.mode == HTHGameMode.NORMAL_AVALANCHE && response.nextMode == HTHGameMode.NORMAL){
            win = response.accumulatedRoundWin;
        }


        if (response.mode.includes("FREESPIN") && (response.wasFeatureBuy || response.boostedBet)){
            const betPrice = HTHHelper.getBuyFeaturePrice();
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }
        if (response.mode === "EXTRA_SPIN" && response.nextMode === "NORMAL" && (response.wasFeatureBuy || response.boostedBet)) {
            const betPrice = HTHHelper.getBuyFeaturePrice();
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private getSpinWin(response: IHTHGameData, bet: number, prevData:IHTHGameData): number {
            return response.spinWin;
    }

    private isFreeSpinTriggered(response: IHTHGameData): boolean {
        return (response.mode === HTHGameMode.NORMAL || response.mode === HTHGameMode.NORMAL_AVALANCHE) && response.nextMode === HTHGameMode.FREESPIN;
    }

    private getFeatureName(response: IHTHGameData): string {
        if (response.mode == HTHGameMode.FREESPIN || response.nextMode == HTHGameMode.FREESPIN || response.mode == HTHGameMode.FREESPIN_AVALANCHE || response.nextMode==HTHGameMode.FREESPIN_AVALANCHE || (response.mode==HTHGameMode.EXTRA_SPIN)){
            return "HELL SPINS";
        }
        return "";
    }

    private isRoundComplete(response: IHTHGameData): boolean {
        return ([HTHGameMode.FREESPIN, HTHGameMode.NORMAL].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: IHTHGameData): boolean {
        return ((response.nextMode === HTHGameMode.NORMAL) && (response.mode === HTHGameMode.FREESPIN || response.mode ===  HTHGameMode.FREESPIN_AVALANCHE));
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN) {
            HTHSound.playTrack(HTHSound.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            HTHSound.playTrack(HTHSound.AS_WIN_BIG);
        }
    }

    public onPlayBonusInGame(data:any){

       // HTH.model.isPlayBonusTrigerred=true;
        HTH.apiPlugin.slotStates.resetGameStartedAndGameServerFlag();
        HTH.model.xNudgePositionPerReel=[[], [], [], [], [], []];
        HTH.model.onGame(data);
        RestoreUtils.startUpGame(false,true);
        HTH.gameFlowController.start();

    }

}